import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {map} from "rxjs/operators";

import { Transaction } from '../enums/txn-type.enum';
import { CommonTransformationService } from './../services/common-transformation.service';

@Injectable()
export class SubmittedForDataService {

  constructor (private http: HttpClient, private transform: CommonTransformationService) { }

  getTxnTypes(): Observable<any> {
    const url = '/approval/worklist/txn-types';

    return this.http.get(url);
  }

  getSubmittedFor(txnType: Transaction | number): Observable<any> {
    let url = `/delegation/submitted-fors/self?`;

    if (typeof txnType === "number") {
      url += `transactionId=${txnType}`;
    } else {
      url += `transaction=${txnType}`;
    }

    return this.http.get(url);
  }

  getSubmittedForAsDropDown(txnType: Transaction | number): Observable<any> {

    return this.getSubmittedFor(txnType).pipe(map(res => {
      return this.transform.convertToDropDown("fullName", res.list, null);
    }));
  }
}
